<script lang="ts">
    import { Observable } from "rxjs";

    type T = $$Generic;
    export let observable: Observable<T>;
</script>

<slot value={$observable} />
